$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/profile/'+param+'?apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(i, elem){
        
          var Market_Cap = nFormatter(elem.mktCap, 2);
          $('#marketcap').append(Market_Cap);

          var Company_Name = elem.companyName;
          $('#stat_company_name').append(Company_Name);
          $('#stat_company_name2').append(Company_Name);
          $('#stat_company_name3').append(Company_Name);        
          $('#stat_company_name4').append(Company_Name); 
          $('#stat_company_name5').append(Company_Name); 
          $('#stat_company_name6').append(Company_Name);
          $('#stat_company_name7').append(Company_Name);
          $('#stat_company_name8').append(Company_Name);
          $('#stat_company_name9').append(Company_Name);

          var Company_Currency = elem.currency;
          $('#stat_company_currency').append(Company_Currency);
          $('#header_company_currency').append(Company_Currency);
          
          var Exchange = elem.exchangeShortName;
          $('#exchange').append(Exchange);
          $('#exchange2').append(Exchange);  

          var Volume = nFormatter(elem.volAvg, 2);
          $('#avg_volume').append(Volume);

          var Beta = nFormatter(elem.beta, 2);
          $('#beta').append(Beta);

          var Week_range = elem.range;
          $('#52_week_range').append(Week_range);

          var Company_ceo = elem.ceo;
          $('#company_ceo').append(Company_ceo);
          $('#company_ceo_profile').append(Company_ceo);
          $('#company_ceo_profile2').append(Company_ceo);

          var ipo_d = new Date(elem.ipoDate);
          var options = { year: 'numeric', month: 'short', day: 'numeric' };
          var Company_ipo_date= ipo_d.toLocaleDateString('en-US', options);
          $('#company_ipo_date').append(Company_ipo_date);
          $('#company_ipo_date_profile').append(Company_ipo_date);
          $('#company_ipo_date_profile2').append(Company_ipo_date);

          var Company_industry = elem.industry;
          $('#company_industry').append(Company_industry);
          $('#company_industry2').append(Company_industry);        
          $('#company_industry_profile').append(Company_industry);
          $('#company_industry_profile2').append(Company_industry);

          var Company_employees = nFormatter(elem.fullTimeEmployees, 2);
          $('#company_employees').append(Company_employees);
          $('#company_employees_profile').append(Company_employees);
          $('#company_employees_profile2').append(Company_employees);
        

          var Company_website = '<a target="_blank" rel="noreferrer" href="'+elem.website+'">'+elem.website+'</a>';
          $('#company_website').append(Company_website);
          $('#company_site').append(Company_website);
          $('#company_site2').append(Company_website);        
          $('#company_site3').append(Company_website); 
          $('#company_site4').append(Company_website); 

          var Company_description = elem.description;
          $('#company_description').append(Company_description);

          var Company_long_description = elem.description;
          $('#company_description_profile').append(Company_long_description);

          var Сompany_country = elem.country;
          $('#company_country').append(Сompany_country);
          $('#company_country2').append(Сompany_country);
          $('#company_country3').append(Сompany_country);
        

          var Сompany_city = elem.city;
          $('#company_city').append(Сompany_city);
          $('#company_city2').append(Сompany_city);

          var Сompany_address = elem.address;
          $('#company_address').append(Сompany_address);
          $('#company_address2').append(Сompany_address);

          var Symbol = elem.symbol;
          $('#symbol').append(Symbol);
          $('#symbol2').append(Symbol);
          $('#symbol3').append(Symbol);
        
          var Long_exchange = elem.exchange;
          $('#long_exchange').append(Long_exchange);
          $('#long_exchange2').append(Long_exchange);

          var Company_sector = elem.sector;
          $('#company_sector').append(Company_sector);        
          $('#company_sector2').append(Company_sector);
          $('#company_sector3').append(Company_sector); 

      });
    });
});
